<nz-layout class="content-section">
  <nz-content>
    <div class="mex-grid-container">
      <app-mex-grid-tab></app-mex-grid-tab>
      <!-- <div nz-row nzType="flex">
        <div nz-col nzSpan="24"> -->
      <!-- <div id="test"></div> -->
      <!-- <router-outlet></router-outlet> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>
  </nz-content>
  <nz-sider
    [hidden]="!showRightSidebar"
    [ngClass]="!disabledSidebar ? 'rightSider' : 'rightSider disabled'"
    nzTheme="light"
    nzCollapsible
    [(nzCollapsed)]="isRightsideBarCollapsed"
    [nzCollapsedWidth]="0"
    [nzZeroTrigger]="rightSiderArrowTemplate"
    (nzCollapsedChange)="rightSiderCollapseChanged($event)"
  >
    <app-right-panel
      [activePanel]="rightSidebarActivePanel"
      (onPanelChange)="handleRightsidebarPanelChange($event)"
    ></app-right-panel>
  </nz-sider>

  <ng-template #rightSiderArrowTemplate>
    <va-icon
      *ngIf="isRightsideBarCollapsed"
      name="arrow-circle-left"
      class="fa fa-md side-arrow"
    ></va-icon>
    <va-icon
      *ngIf="!isRightsideBarCollapsed"
      name="arrow-circle-right"
      class="fa fa-md side-arrow"
    ></va-icon>
  </ng-template>

  <app-custom-consensus-nodata-modal></app-custom-consensus-nodata-modal>
  <app-custom-consensus-modal> </app-custom-consensus-modal>
</nz-layout>
